export default {
  // Get the Page Status Code
  statusCode(state) {
    return state.statusCode
  },

  // Get the Debug flag
  debug(state) {
    return state.debug
  },

  // Get the use Cache Flag
  useCache(state) {
    return state.useCache
  },

  // Get the Page Breadcrumbs
  breadcrumbs(state) {
    return state.breadcrumbs
  },

  // Get the IS MOBILE flag
  isMobile(state) {
    return state.isMobile
  },

  // Get the benners info
  banners(state) {
    return state.banners
  },

  // Get the expiresAt timestamp
  expiresAt(state) {
    return state.expiresAt
  },

  // Get the faqs timestamp
  faqs(state) {
    return state.faqs
  },

  pageQueryParams(state) {
    return state.pageQueryParams
  },

  pageQueryParamsToString(state) {
    if (!Object.hasOwn(state.pageQueryParams, process.env.OPTIONS_ADD_QUERY_STRING_TO_URL_KEY)) {
      return ''
    }
    return `${process.env.OPTIONS_ADD_QUERY_STRING_TO_URL_KEY}=${state.pageQueryParams[process.env.OPTIONS_ADD_QUERY_STRING_TO_URL_KEY]}`
  },

  // Preview Mode getters
  isPreview(state) {
    return state.isPreview === true
  },
  previewVersion(state) {
    return state.previewVersion
  },
  previewTag(state) {
    return state.previewTag
  },
  previewEntityId(state) {
    return state.previewEntityId
  },
  previewId(state) {
    return state.previewId
  },
  previewCreatedAt(state) {
    return state.previewCreatedAt
  },
  previewGeneratedBy(state) {
    return state.previewGeneratedBy
  },
  previewError(state) {
    return state.previewError
  },
  isSitewidePreview(state) {
    return state.isSitewidePreview === true
  },
  sitewidePreviewDesktop(state) {
    return state.sitewidePreviewDesktop
  },
  sitewidePreviewMobile(state) {
    return state.sitewidePreviewMobile
  }
}
